import { DEDUCTIONS } from "..";
import { apiInstance } from "../config/apiInstance";

export type GetDeductionsParams = {
  conceptCode?: string;
  operatingIndicator?: string;
  page?: number;
  size?: number;
  search?: string;
};

export type DeductionItem = {
  id: number;
  conceptCode: string;
  conceptDescription: string;
  accountingAccount: string;
  percentage: number;
  fiscalYear: number;
  effectiveStartDate: string;
  effectiveEndDate: string;
  operatingIndicator: string;
  beneficiary: string;
  beneficiaryName: string;
};

export type GetDeductionsResponse = {
  content: DeductionItem[];
  totalElements: number;
  number: number;
  size: number;
  contentSize: number;
};

export const getDeductions = async (
  params?: GetDeductionsParams,
): Promise<GetDeductionsResponse> => {
  const response = await apiInstance.get<GetDeductionsResponse>(DEDUCTIONS, {
    params,
  });
  return response.data;
};
